import { h } from 'preact'

import { IconComponentProps } from './index'

export default ({ width = 160, height = 160, color = 'currentColor', customClass }: IconComponentProps) => <svg width={width} height={height} viewBox='0 0 160 160' class={customClass} >
  <rect width='160' height='160' rx='2' fill='#04363F' />
  <path d='M75.8126 59.5505V120.853H25L75.8126 59.5505Z' fill='white' />
  <path d='M75.8138 37.5282C75.8138 51.5426 64.45 62.9345 50.4075 62.9063C36.3931 62.9063 25.0012 51.5426 25.0293 37.5L75.8138 37.5282Z' fill='white' />
  <path d='M84.1592 120.881C84.1592 106.866 95.5511 95.4745 109.565 95.5027C123.58 95.5027 134.972 106.866 134.944 120.909L84.1592 120.881Z' fill='white' />
  <path d='M84.1875 98.8589V37.5284L135 37.5566L84.1875 98.8589Z' fill='white' />
</svg>
